import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "app" }

import { RouterLink, RouterView } from 'vue-router'
import Layout from '@/components/layout'
import { useRoute } from 'vue-router'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const local = i18n.global.locale

const enClass = local === 'en'

if (enClass) {
  document.body.className = 'ws_en'
}

const $route = useRoute()

return (_ctx: any,_cache: any) => {
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_unref($route).meta.layout)
          ? (_openBlock(), _createBlock(_unref(RouterView), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(Layout), { key: 1 }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_unref(RouterView), {
                  key: _unref($route).fullPath
                }))
              ]),
              _: 1
            }))
      ])
    ]),
    _: 1
  }))
}
}

})